import React from 'react';
import LocalizedStrings from 'react-localization';
import Widget from '../Widget/Widget.js';
import ReactTable from 'react-table'
import Scroll from 'react-scroll';
import 'react-table/react-table.css'
import './SavedSearchTableViewWidget.css';
var scroll = Scroll.animateScroll;
var Events = Scroll.Events;

class SavedSearchTableViewWidget extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      reverseScroll:false,
      scrollDuration:60
    };

    this.strings = new LocalizedStrings({
     en:{
       noData: 'No data available'
     },
     de: {
       noData: 'Keine Daten verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  scrollTable(to, element) {
    if(this.state.reverseScroll) {
      this.scrollDown()
    } else {
      this.scrollUp()
    }
    this.setState({
      ...this.state,
      reverseScroll:this.state.reverseScroll ? false : true
    })
  }

  scrollDown() {
    const tableBodyId = "table-body-"+this.props.savedSearchId
    scroll.scrollToBottom({
      containerId:tableBodyId,
      duration:this.props.autoScrollDuration*1000,
      smooth:"linear",
      delay:3000,
      ignoreCancelEvents:true
    });
  }

  scrollUp() {
    const tableBodyId = "table-body-"+this.props.savedSearchId
    scroll.scrollToTop({
      containerId:tableBodyId,
      duration:this.props.autoScrollDuration*1000,
      smooth:"linear",
      ignoreCancelEvents:true
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.search.rows.length === 0 && this.props.search && this.props.search.rows && this.props.search.rows.length > 0 && this.props.autoScroll) {
      this.scrollDown()
      Events.scrollEvent.register('end', this.scrollTable.bind(this));
    }
  }

  componentWillUnmount() {
    Events.scrollEvent.remove('end');
  }

  getTableBodyProps(state, rowInfo, column, instance) {
    return {
      id:"table-body-"+this.props.savedSearchId
    }
  }

  renderTable() {

    if(!this.props.search || this.props.search.rows.length === 0) {
      return (<h2 className="text-center">{ this.strings.noData }</h2>);
    }

    var headers = this.props.search.headers.map(function(header){
      return {
        Header:header,
        accessor:header,
        headerClassName:'search-table-view-widget-header'
      }
    },this)

    const style = {
      "maxHeight":((this.props.rowHeight*this.props.size.h)-75)+"px"
    }

    const reactTableStyle = {
      height:((this.props.rowHeight*this.props.size.h)-75)
    }

    return (
      <div className="saved-search-table-widget-container" style={style}>
        <ReactTable
          className="-striped"
          data={this.props.search.rows}
          columns={headers}
          style={reactTableStyle}
          showPageSizeOptions={false}
          defaultPageSize={this.props.search.rows.length}
          showPagination={false}
          getTbodyProps={this.getTableBodyProps.bind(this)}
        />
      </div>
    )
  }

  render() {

    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <h1 className="text-center">{this.props.title}</h1>
            {this.renderTable()}
          </div>
        </div>
      </Widget>
    )

  }
}

export default SavedSearchTableViewWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/SavedSearchTableViewWidget/SavedSearchTableViewWidget.js